import { render, staticRenderFns } from "./customerBank.vue?vue&type=template&id=33637221"
import script from "./customerBank.vue?vue&type=script&lang=js"
export * from "./customerBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports